module.exports = __webpack_public_path__ + "img/info-9.0c53ad6c.svg";